import { useEffect, useRef, useState } from "react";

/**
 * Tracks vertical scroll direction with a small delta threshold so tiny
 * jitters don't flip state. Yields { scrollY, direction }.
 *   direction: 'up' | 'down'
 * At the top of the page, direction is always 'up'.
 */
export function useScrollDirection(threshold = 6) {
  const [scrollY, setScrollY] = useState(
    typeof window !== "undefined" ? window.scrollY : 0,
  );
  const [direction, setDirection] = useState("up");
  const lastY = useRef(scrollY);

  useEffect(() => {
    let ticking = false;
    const update = () => {
      const currentY = window.scrollY;
      const delta = currentY - lastY.current;
      if (Math.abs(delta) > threshold) {
        setDirection(delta > 0 ? "down" : "up");
        lastY.current = currentY;
      }
      if (currentY < 20) setDirection("up");
      setScrollY(currentY);
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return { scrollY, direction };
}
